import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScanVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconScanVoice"><Path d="M9 3.5H3.5V9" stroke="currentColor"/><Path d="M15 3.5H20.5V9" stroke="currentColor"/><Path d="M9 20.5H3.5V15" stroke="currentColor"/><Path d="M15 20.5H20.5V15" stroke="currentColor"/><Path d="M7.5 10V14" stroke="currentColor" strokeLinejoin="round"/><Path d="M16.5 9V15" stroke="currentColor" strokeLinejoin="round"/><Path d="M13.5 10.5V13.5" stroke="currentColor" strokeLinejoin="round"/><Path d="M10.5 7V17" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconScanVoice;
